<template>
  <v-container fluid>
    <v-row dense class="py-3" justify="center">
      <v-col cols="12" sm="6" md="3">
        <CardIndicatorGenero :config="config_indicatorGenero" />
      </v-col>
      <v-col cols="12" sm="6" md="3" justify-end>
        <CardIndicator class="mx-5" :config="config_indicator"/>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <CardIndicator class="mx-5" :config="config_indicator2"/>
      </v-col>
      <v-col cols="12" sm="6" md="3">
        <CardIndicator class="mx-5" :config="config_indicator3"/>
      </v-col>
    </v-row>

    <v-row dense class="py-3">
      <v-col cols="12" sm="6" md="3">
        <CardIndicatorAmount class="mx-2" :config="config_indicatorAmount"/>
        <CardIndicatorAmount class="mx-2 my-3" :config="config_indicatorAmountDepto"/>
        <!-- <CardIndicatorAmount class="mx-2" :config="config_indicatorAmount"/> -->
      </v-col>
      <v-col cols="12" sm="9" md="9">
        <v-row no-gutters>
          <v-col cols="12" sm="6" md="6">
            <BarColumnChart class="mx-2" :data="dataSourceConfig"/>
          </v-col>
          <v-col cols="12" sm="6" md="6">
            <BarColumnChart class="mx-2" :data="dataSourceConfigSalary"/>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col cols="12">
        <DataTableMain :datatable="table" :on-success="successAction" :itemsAction="tableAction"/>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import { Permission } from '@/mixins/permissionMain'
import DataTableMain from '@/components/tables/DataTableMain.vue'

import CardIndicator from '@/components/cards/Card-Indicator.vue'
import CardIndicatorGenero from '@/components/cards/Card-IndicatorGenero.vue'
import CardIndicatorAmount from '@/components/cards/Card-IndicatorAmount.vue'
import BarColumnChart from '@/components/charts/BarColumnChart.vue'

export default {
  mixins: [Permission],
  data: () => ({
    logo: null,
    config_indicatorGenero: {
      background: 'grey lighten-2',
      background_dark: 'grey lighten-4',
      data: {
        name: 'Personal con Falta de Asistencia',
        amount: 30
      }
    },
    config_indicatorAmount: {
      background: 'light-blue accent-2',
      background_dark: 'light-blue accent-4',
      data: {
        name: 'Costo de Planilla',
        amount: '$ 120,000.00'
      }
    },
    config_indicatorAmountDepto: {
      background: 'light-blue accent-2',
      background_dark: 'light-blue accent-4',
      data: {
        name: 'Puestos ocupados de la Planilla',
        amount: '83 %'
      }
    },

    config_indicator: {
      background: 'red darken-2',
      background_dark: 'red darken-4',
      dark: true,
      data: {
        name: 'Personal con Falta de Asistencia',
        amount: 30
      }
    },
    config_indicator2: {
      background: 'lime darken-2',
      background_dark: 'lime darken-4',
      dark: true,
      data: {
        name: 'Personal con Horas Extras',
        amount: 20
      }
    },
    config_indicator3: {
      background: 'light-green darken-2',
      background_dark: 'light-green darken-4',
      dark: true,
      data: {
        name: 'Personal con Asistencia Estable',
        amount: 50
      }
    },

    dataSourceConfig: {
      type: 'bar2d',
      width: '100%',
      height: '350',
      dataSource: {
        chart: {
          caption: 'Numero de Empleados por Departamento',
          subcaption: '',
          xaxisname: 'Departamentos',
          yaxisname: 'Cantidad de Empleados',
          numbersuffix: '',
          theme: 'fusion'
        },
        data: [
          {
            label: 'Dirección General',
            value: '88'
          },
          {
            label: 'Recepción',
            value: '7'
          },
          {
            label: 'Supervisión de Zona',
            value: '59'
          },
          {
            label: 'Comunicación Social',
            value: '20'
          },
          {
            label: 'Relaciones Píblicas',
            value: '30'
          }
        ]
      }
    },
    dataSourceConfigSalary: {
      type: 'bar2d',
      width: '100%',
      height: '350',
      dataSource: {
        chart: {
          caption: 'Salario por Departamento General',
          subcaption: '',
          xaxisname: 'Departamentos',
          yaxisname: 'Cantidad de Empleados',
          numbersuffix: '',
          theme: 'fusion'
        },
        data: [
          {
            label: 'Dirección General',
            value: '88000'
          },
          {
            label: 'Recepción',
            value: '70000'
          },
          {
            label: 'Supervisión de Zona',
            value: '59000'
          },
          {
            label: 'Comunicación Social',
            value: '20000'
          },
          {
            label: 'Relaciones Píblicas',
            value: '30000'
          }
        ]
      }
    },

    table: {
      modelMain: [],
      showSelect: false,
      singleSelect: true,
      header: {
        options: [],
        titles: [
          { text: 'Responsable', value: 'nombrecompleto', class: 'black--text' },
          { text: 'Usuario', value: 'usuario', class: 'black--text' },
          { text: 'Departamento', value: 'departamento', class: 'black--text' },
          { text: 'Total Hrs. extra', value: 'pendienteMA', class: 'black--text', align: 'center' },
          { text: 'Total Faltas', value: 'totalMA', class: 'black--text', align: 'center' },
          { text: 'Estables', value: 'pendienteSE', class: 'black--text', align: 'center' }
        ],
        loading: false
      },
      body: {
        data: [
          {
            nombrecompleto: 'Catherine Estrada',
            usuario: 'catherine.estrada',
            departamento: 'Recursos Humanos',
            pendienteMA: '0',
            totalMA: '0',
            pendienteSE: '0'
          },
          {
            nombrecompleto: 'Clara Canul',
            usuario: 'clara.canul',
            departamento: 'Administracion',
            pendienteMA: '0',
            totalMA: '0',
            pendienteSE: '0'
          },
          {
            nombrecompleto: 'Charles Estrella',
            usuario: 'Charles.estrella',
            departamento: 'Contabilidad',
            pendienteMA: '0',
            totalMA: '0',
            pendienteSE: '0'
          },
          {
            nombrecompleto: 'Chloe Escalante',
            usuario: 'Chloe.escalante',
            departamento: 'Zona 1',
            pendienteMA: '0',
            totalMA: '0',
            pendienteSE: '0'
          },
          {
            nombrecompleto: 'Christopher Martin',
            usuario: 'Christopher.martin',
            departamento: 'Zona 2',
            pendienteMA: '0',
            totalMA: '0',
            pendienteSE: '0'
          }
        ],
        actions: []
      },
      footer: {
        paging: true
      }
    }
  }),
  components: {
    DataTableMain,
    CardIndicator,
    CardIndicatorGenero,
    CardIndicatorAmount,
    BarColumnChart
  },
  mounted () {
    this.PermisosMenu(JSON.parse(localStorage.getItem('permisos')), this.actionsEisy)
  },
  beforeMount () {
    this.GETUrlLogoSistema('imagen-home')
  },
  methods: {
    ...mapActions(['GETUrlLogoSistema']),
    ...mapMutations([]),
    successAction (item) {
      this[item.action](item)
    },

    tableAction (item) {
      this[item.action](item)
    }
  },
  computed: {
    ...mapGetters(['get_logo'])
  },
  watch: {
    get_logo (logo) {
      this.logo = `${logo.formato}${logo.imagen}`
    }
  }
}
</script>
<style scoped>
.hiddenItem {
  display: none;
}
</style>
